import styled from 'styled-components';

const ErrorText = styled.p`
  color: red;
  font-weight: bold;
`;

export default ErrorText;